/* eslint-disable prefer-destructuring */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-lines-per-function */
import { Checkbox } from "@atlaskit/checkbox";
import Select from "@atlaskit/select";
import { ReactElement } from "react";
import { SlotsStartTimes } from "../../containers/WorkingTimeSlots/slots_start_times";
import "./TimeSlotDay.scss";

export interface TimeSlotsDay {
    id?: number;
    startTime: string | undefined;
    endTime: string | undefined;
    dayEnabled: boolean;
    day: number;
    dayLabel: string;
    isChanged: boolean;
}

interface Props {
    time: TimeSlotsDay;
    index: number;
    onChange: (index: number, times: Partial<TimeSlotsDay>) => void;
}
export const getworkingHours = (): string[] => {
    const workingHours = [];
    for (let indx = 0; indx < 24; indx++) {
        workingHours.push(`${indx < 10 ? `0${indx}` : indx}:00`);
    }
    return workingHours;
};

const getCorrectlyFormatedTime = (hourOrMinute: number): string => {
    const hourOrMinuteAsString = `${hourOrMinute}`;
    if (hourOrMinuteAsString.length === 1) {
        return `0${hourOrMinuteAsString}`;
    }
    return hourOrMinuteAsString;
};

export const getTimeSlotsFor70MinuteSlots = (): string[] => {
    const workingHours = [];

    for (let indx = 0; indx < SlotsStartTimes.length; indx++) {
        const slotTime = SlotsStartTimes[indx];

        workingHours.push(
            `${getCorrectlyFormatedTime(
                slotTime.hour
            )}:${getCorrectlyFormatedTime(slotTime.minute)}`
        );
    }

    return workingHours;
};

export default function TimeSlotDay({
    onChange,
    index,
    time,
}: Props): ReactElement {
    return (
        <div className="time-slot-day-container">
            <div className="time-slot-day-checkbox">
                <Checkbox
                    label={time.dayLabel}
                    onChange={(event) => {
                        onChange(index, {
                            dayEnabled: Boolean(event.target.checked),
                            isChanged: true,
                        });
                    }}
                    name="checkbox-default"
                    testId="cb-default"
                    isChecked={time.dayEnabled}
                />
            </div>
            <div className="time-slot-day-item">
                <div className="time-slot-day-label">Start:</div>

                <Select
                    onChange={(value) => {
                        onChange(index, {
                            startTime: value?.value,
                        });
                    }}
                    isMulti={false}
                    options={getTimeSlotsFor70MinuteSlots().map((el) => ({
                        value: el,
                        label: el,
                    }))}
                    value={{
                        value: time.startTime,
                        label: time.startTime,
                    }}
                    closeMenuOnSelect={true}
                    popperProps={{
                        placement: "bottom",
                        strategy: "fixed",
                    }}
                    isLoading={false}
                />
            </div>
            <div className="time-slot-day-item">
                <div className="time-slot-day-label">End:</div>
                <Select
                    onChange={(value) => {
                        onChange(index, {
                            endTime: value?.value,
                        });
                    }}
                    isMulti={false}
                    options={getTimeSlotsFor70MinuteSlots().map((el) => ({
                        value: el,
                        label: el,
                    }))}
                    value={{
                        value: time.endTime,
                        label: time.endTime,
                    }}
                    closeMenuOnSelect={true}
                    popperProps={{
                        placement: "bottom",
                        strategy: "fixed",
                    }}
                    isLoading={false}
                />
            </div>
        </div>
    );
}
